module.exports = __webpack_public_path__ + "img/berlin.daf941a.webp";